import $ from 'jquery';
import 'slick-carousel';
export default {
  init: function init() {},
  finalize: function finalize() {
    var $machineSlider = $('.js-machine-slider .slider');

    if ($machineSlider.get(0)) {
      $machineSlider.slick({
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1000,
        dots: false,
        arrows: true,
        infinite: true,
        appendArrows: $('.p-machine-list-arrow'),
        prevArrow: '<a class="p-machine-list-prev"></a>',
        nextArrow: '<a class="p-machine-list-next"></a>',
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        centerPadding: '20%'
      });
    }
  }
};